import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Subtitle1 } from '@src/elements/typography/typography'

import { stopPropagation } from '@src/util/functions'

import './cookie-banner.sass'
import Cookies from '@src/lib/cookies'

@Component
export class CookieBanner extends Vue {

  private show: boolean = false

  created () {
    if (!Cookies.get('Cookies')) {
      this.show = true
    }
  }

  render (h: CreateElement) {
    return (
      <transition name='fade' mode='out-in' appear>
        {this.show ? <div class={'cookie-banner'}>
          <span><Subtitle1>{`${this.$t('COOKIES.DESCRIPTION')} `}<a class='cookies-link' target='_blank' href='https://www.pixformance.com/imprint/'>{this.$t('COOKIES.PRIVACY_POLICY')}</a>.</Subtitle1></span>
          <div class='accept' onClick={this.acceptCookieBanner}><Subtitle1>{this.$t('ACCEPT')}</Subtitle1></div>
        </div> : ''}
      </transition>)
  }

  protected acceptCookieBanner (e) {
    this.show = false
    Cookies.set('Cookies', 'accepted', { expires: '5Y' })
    // click outside popup must not be triggered
    stopPropagation(e)
  }
}
